import Cell from './elements/Cell'
import type { ColumnConfig, ColumnField } from './types'

function HeaderDataCell<T extends Record<string, unknown>, K extends ColumnField<T>>({
  label,
  width,
  minWidth,
  maxWidth,
  children,
  className,
}: Pick<ColumnConfig<T, K>, 'label' | 'width' | 'minWidth' | 'maxWidth'> & {
  children?: React.ReactNode
  className?: string
}) {
  return (
    <Cell as="th" className={className} width={width} minWidth={minWidth} maxWidth={maxWidth}>
      {label}
      {children}
    </Cell>
  )
}

export default HeaderDataCell
